var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold",attrs:{"small":"","outlined":"","color":_vm.color}},[_vm._v(_vm._s(_vm.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }